import KeenSlider from 'keen-slider';

window.addEventListener('load', function() {
  let carousels = document.querySelectorAll('.carousel');
  carousels.forEach(carousel => {
    function navigation(slider) {
      let wrapper, dots, arrowLeft, arrowRight;
      var enableDots =
        carousel.getAttribute('data-dots') == 'true' ? true : false;
      var enableArrows =
        carousel.getAttribute('data-arrows') == 'true' ? true : false;
      var chevron = carousel.getAttribute('data-chevron') == 'true';

      function markup(remove) {
        wrapperMarkup(remove);
        if (enableDots) {
          dotMarkup(remove);
        }
        if (enableArrows) {
          arrowMarkup(remove);
        }
      }

      function removeElement(elment) {
        elment.parentNode.removeChild(elment);
      }
      function createDiv(className) {
        var div = document.createElement('div');
        var classNames = className.split(' ');
        classNames.forEach(name => div.classList.add(name));
        return div;
      }

      function createButton(className) {
        var button = document.createElement('button');
        var classNames = className.split(' ');
        classNames.forEach(name => button.classList.add(name));
        return button;
      }

      function arrowMarkup(remove) {
        if (remove) {
          removeElement(arrowLeft);
          removeElement(arrowRight);
          return;
        }
        arrowLeft = createButton('arrow arrow--left');
        arrowLeft.addEventListener('click', () => slider.prev());
        arrowRight = createButton('arrow arrow--right');
        arrowRight.addEventListener('click', () => slider.next());

        if (chevron) {
          arrowLeft.classList.add('gg-chevron-left');
          arrowRight.classList.add('gg-chevron-right');
        } else {
          arrowLeft.classList.add('gg-chevron-left-o');
          arrowRight.classList.add('gg-chevron-right-o');
        }

        const arrows = document.createElement('div');
        arrows.classList.add('flex', 'carousel-arrows');
        arrows.append(arrowLeft);
        arrows.append(arrowRight);
        wrapper.append(arrows);
      }

      function wrapperMarkup(remove) {
        if (remove) {
          var parent = wrapper.parentNode;
          while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper);
          removeElement(wrapper);
          return;
        }
        wrapper = createDiv('navigation-wrapper');
        slider.container.parentNode.appendChild(wrapper);
        wrapper.appendChild(slider.container);
      }

      function dotMarkup(remove) {
        if (remove) {
          removeElement(dots);
          return;
        }
        dots = createDiv('dots');
        slider.track.details.slides.forEach((_e, idx) => {
          var dot = createDiv('dot');
          dot.addEventListener('click', () => slider.moveToIdx(idx));
          dots.appendChild(dot);
        });
        wrapper.appendChild(dots);
      }

      function updateClasses() {
        var slide = slider.track.details.rel;
        if (enableArrows) {
          slide === 0
            ? arrowLeft.classList.add('arrow--disabled')
            : arrowLeft.classList.remove('arrow--disabled');
          slide === slider.track.details.slides.length - 1
            ? arrowRight.classList.add('arrow--disabled')
            : arrowRight.classList.remove('arrow--disabled');
        }
        if (enableDots) {
          Array.from(dots.children).forEach(function(dot, idx) {
            idx === slide
              ? dot.classList.add('dot--active')
              : dot.classList.remove('dot--active');
          });
        }
      }

      slider.on('created', () => {
        markup();
        updateClasses();
      });
      slider.on('optionsChanged', () => {
        markup(true);
        markup();
        updateClasses();
      });
      slider.on('slideChanged', () => {
        updateClasses();
      });
      slider.on('destroyed', () => {
        markup(true);
      });
    }

    let wrapper = carousel.querySelector(
      '.elementor-container, .elementor-posts-container, .products, .wp-block-columns, .gallery'
    );

    if (wrapper == null) {
      wrapper = carousel;
    }

    var desktopSlides = carousel.getAttribute('data-slides-desktop') || 3;
    var mobileSlides = carousel.getAttribute('data-slides-mobile') || 1.5;
    var centered =
      carousel.getAttribute('data-centered') == 'true' ? 'center' : 'auto';
    var loop = carousel.getAttribute('data-loop') == 'true' ? true : false;
    var spacing = carousel.getAttribute('data-gap') || 16;
    var autoSlide = carousel.getAttribute('data-auto-slide');
    var render = autoSlide
      ? 'performance'
      : carousel.getAttribute('data-render') || 'precision';
    var duration = carousel.getAttribute('data-duration') || 50000;
    var direction =
      carousel.getAttribute('data-direction') == 'right' ? true : false;
    var autoWidth =
      carousel.getAttribute('data-auto-width') == 'true' ? true : false;
    var mode = carousel.getAttribute('data-mode') || 'free-snap';

    Array.prototype.forEach.call(wrapper.children, child => {
      child.classList.add('keen-slider__slide');
    });

    wrapper.classList.add('keen-slider');
    if (autoWidth) {
      wrapper.classList.add('auto-width');
    }

    wrapper.style.display = 'flex';
    wrapper.style.gridColumnGap = '0';
    //wrapper.style.gap = spacing + 'px';

    var animation = { duration: duration, easing: t => t };

    var options = {
      loop: loop,
      mode: mode,
      render: render,
      rtl: direction,
      slides: {
        perView: autoWidth ? 'auto' : desktopSlides,
        spacing: spacing,
        origin: centered,
      },
      breakpoints: {
        '(max-width: 767px)': {
          slides: {
            perView: autoWidth ? 'auto' : mobileSlides,
            spacing: spacing,
            origin: centered,
          },
        },
      },
      created(s) {
        autoSlide ? s.moveToIdx(5, true, animation) : '';
      },
      updated(s) {
        autoSlide ? s.moveToIdx(s.track.details.abs + 5, true, animation) : '';
      },
      animationEnded(s) {
        autoSlide ? s.moveToIdx(s.track.details.abs + 5, true, animation) : '';
      },
    };

    var slider = new KeenSlider(wrapper, options, [navigation]);
  });
});
